import { graphql } from "@/gen";

export const tournamentLayoutsQuery = graphql(`
    query TournamentLayouts(
        $tournamentId: UUID!
        $tournamentPhase: TournamentPhase
        $limit: Int!
        $offset: Int!
    ) {
        tournamentLayouts(
            input: {
                tournamentId: $tournamentId
                tournamentPhase: $tournamentPhase
                pagination: { limit: $limit, offset: $offset }
            }
        ) {
            total
            items {
                id
                name
                createdAt
                updatedAt
                tournamentPhase
                publishAt
                unpublishAt
                content
            }
        }
    }
`);

export const createTournamentLayoutMutation = graphql(`
    mutation CreateTournamentLayout($input: CreateTournamentLayoutInput!) {
        createTournamentLayout(input: $input) {
            id
        }
    }
`);

export const deleteTournamentLayoutMutation = graphql(`
    mutation DeleteTournamentLayout($input: DeleteTournamentLayoutInput!) {
        deleteTournamentLayout(input: $input) {
            id
        }
    }
`);
